import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-900" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "flex justify-between h-16" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"-ml-2 mr-2 flex items-center md:hidden\"><button type=\"button\" class=\"inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white\" aria-controls=\"mobile-menu\" aria-expanded=\"false\"><span class=\"sr-only\">Open main menu</span><svg class=\"block h-6 w-6\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" aria-hidden=\"true\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M4 6h16M4 12h16M4 18h16\"></path></svg><svg class=\"hidden h-6 w-6\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" aria-hidden=\"true\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M6 18L18 6M6 6l12 12\"></path></svg></button></div><div class=\"flex-shrink-0 flex items-center\"><img class=\"block lg:hidden h-8 w-auto\" src=\"https://soliditytips.com/terminal-icon.png\" alt=\"SolidityTips.com logo\"><img class=\"hidden lg:block h-8 w-auto\" src=\"https://soliditytips.com/terminal-icon.png\" alt=\"SolidityTips.com logo\"></div>", 2)
const _hoisted_7 = { class: "hidden md:ml-6 md:flex md:items-center md:space-x-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Wave Me")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Lucky number")
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "flex-shrink-0" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 mr-2",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M17.778 8.222c-4.296-4.296-11.26-4.296-15.556 0A1 1 0 01.808 6.808c5.076-5.077 13.308-5.077 18.384 0a1 1 0 01-1.414 1.414zM14.95 11.05a7 7 0 00-9.9 0 1 1 0 01-1.414-1.414 9 9 0 0112.728 0 1 1 0 01-1.414 1.414zM12.12 13.88a3 3 0 00-4.242 0 1 1 0 01-1.415-1.415 5 5 0 017.072 0 1 1 0 01-1.415 1.415zM9 16a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_15 = { class: "" }
const _hoisted_16 = {
  class: "md:hidden",
  id: "mobile-menu"
}
const _hoisted_17 = { class: "px-2 pt-2 pb-3 space-y-1 sm:px-3" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Wave me")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Lucky number")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: { name: 'Home' },
              class: "bg-gray-900 text-white px-3 py-2 rounded-md text-sm font-medium",
              "aria-current": "page"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: { name: 'WaveMe' },
              class: "text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: { name: 'LuckyNumber' },
              class: "text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              disabled: _ctx.walletStore.walletData != null,
              class: _normalizeClass([
                _ctx.walletStore.walletData == null ? 'hover:bg-indigo-600' : ''
              , "relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-indigo-500"]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.connectWallet()))
            }, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.walletStore.walletData != null
                  ? `Connected ${_ctx.walletStore.walletData.slice(
                      0,
                      2
                    )}...${_ctx.walletStore.walletData.slice(-4)}`
                  : `Connect Wallet`), 1)
            ], 10, _hoisted_13)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_router_link, {
          to: { name: 'Home' },
          class: "bg-gray-900 text-white block px-3 py-2 rounded-md text-base font-medium",
          "aria-current": "page"
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'WaveMe' },
          class: "text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'WaveMe' },
          class: "text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        })
      ])
    ])
  ]))
}